/* loaded by smart-asset */
export default require("./spinner~lXyaedYq.gif")